import { Col, DatePicker, Form, Input, Row, Space, Typography } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../components/DraggableModal";
import SelectGovernment from "../../../components/selects/SelectGovernment";
import { EntFinancialIndicators } from "../../../models/mechanization/financialIndicators";
import { dateFormat } from "../../../utils";
import dayjs from "dayjs";

enum FormField {
    id, // Идентификатор записи
    periodStart, // Дата начала периода
    periodEnd, // Дата окончания периода
    budgetRepublican, // Республиканский бюджет
    budgetSpecialAccount, // Специальный счет
    budgetDonorFunds, // Предоставленные донорами
    budgetOther, // Другое бюджет
    budgetOtherDescription, // Дополнительные средства на инфраструктуру
    expensesSalary, // Заработная плата и социальные выплаты
    expensesRealEstateMaintenance, // Обслуживание недвижимого имущества
    expensesMovableProperty, // Обслуживание движимого имущества
    expensesOther, // Прочие расходы
    expensesOtherDescription, // Непредвиденные расходы (Описание)
    government, // Идентификатор организации
}

interface IProps {
    show: boolean;
    financialIndicators: EntFinancialIndicators;
    onHide: () => void;
    onSubmit: (pos: EntFinancialIndicators) => Promise<boolean>;
}

export const AddFinancialIndicatorsModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const [startDate, setStartDate] = useState(null);
    const { Text } = Typography;
    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);

    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: FormField.periodStart, value: props.financialIndicators.periodStart === null ? undefined : dayjs(props.financialIndicators.periodStart) },
            { name: FormField.periodEnd, value: props.financialIndicators.periodEnd === null ? undefined : dayjs(props.financialIndicators.periodEnd) },
            { name: FormField.budgetRepublican, value: props.financialIndicators.budgetRepublican },
            { name: FormField.budgetSpecialAccount, value: props.financialIndicators.budgetSpecialAccount },
            { name: FormField.budgetDonorFunds, value: props.financialIndicators.budgetDonorFunds },
            { name: FormField.budgetOther, value: props.financialIndicators.budgetOther },
            { name: FormField.budgetOtherDescription, value: props.financialIndicators.budgetOtherDescription },
            { name: FormField.expensesSalary, value: props.financialIndicators.expensesSalary },
            { name: FormField.expensesRealEstateMaintenance, value: props.financialIndicators.expensesRealEstateMaintenance },
            { name: FormField.expensesMovableProperty, value: props.financialIndicators.expensesMovableProperty },
            { name: FormField.expensesOther, value: props.financialIndicators.expensesOther },
            { name: FormField.expensesOtherDescription, value: props.financialIndicators.expensesOtherDescription },
            { name: FormField.government, value: props.financialIndicators.government?.id },
        ]);
    };

    const setEntityFromFields = (): EntFinancialIndicators => {
        let res = _.cloneDeep(props.financialIndicators);
        res.periodStart = form.getFieldValue(FormField.periodStart);
        res.periodEnd = form.getFieldValue(FormField.periodEnd);
        res.budgetRepublican = form.getFieldValue(FormField.budgetRepublican);
        res.budgetSpecialAccount = form.getFieldValue(FormField.budgetSpecialAccount);
        res.budgetDonorFunds = form.getFieldValue(FormField.budgetDonorFunds);
        res.budgetOther = form.getFieldValue(FormField.budgetOther);
        res.budgetOtherDescription = form.getFieldValue(FormField.budgetOtherDescription);
        res.expensesSalary = form.getFieldValue(FormField.expensesSalary);
        res.expensesRealEstateMaintenance = form.getFieldValue(FormField.expensesRealEstateMaintenance);
        res.expensesMovableProperty = form.getFieldValue(FormField.expensesMovableProperty);
        res.expensesOther = form.getFieldValue(FormField.expensesOther);
        res.expensesOtherDescription = form.getFieldValue(FormField.expensesOtherDescription);
        res.government = form.getFieldValue(FormField.government);
        return res;
    }
    const hideModal = () => {
        props.onHide();
    }
    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
            const result = await props.onSubmit(data);
            if (result) hideModal();
        } finally {
            setLoading(false);
        }
    }


    const handleStartDateChange = (date: any) => {
        setStartDate(date);
    };

    const disableEndDate = (current: any) => {
        return current && current.isBefore(startDate, 'day');
    };
    return (
        <>
            <DraggableModal
                title={props.financialIndicators.id === null ? t('general.add') : t('general.edit')}
                visible={props.show}
                onCancel={() => { hideModal() }}
                onSubmit={handleSubmit}
                submitLoading={loading}
                width={1000}
            >
                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >
                    <Row style={{ margin: 0 }} gutter={16}>
                        <Col className="gutter-row" span={12}>


                            <div className="block_item_form" >
                                <Form.Item
                                    label={t('user.organization')}
                                    name={FormField.government}
                                    rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                                >
                                    <SelectGovernment />
                                </Form.Item>
                            </div>
                            <div className="block_item_form" >
                            <Text underline strong >Раздел источника доходов</Text>
                            <Form.Item
                                label={t('financial_indicators.funds_from_republican_budget')}
                                name={FormField.budgetRepublican}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <Input type="number" />
                            </Form.Item>
                            <Form.Item
                                label={t('financial_indicators.funds_from_special_account')}
                                name={FormField.budgetSpecialAccount}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <Input type="number" />
                            </Form.Item>
                            <Form.Item
                                label={t('financial_indicators.funds_from_donors')}
                                name={FormField.budgetDonorFunds}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <Input type="number" />
                            </Form.Item>
                            <Form.Item
                                label={t('Другое бюджет')}
                                name={FormField.budgetOther}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <Input type="number" />
                            </Form.Item>
                            <Form.Item
                                label={t('Другое бюджет (Описание)')}
                                name={FormField.budgetOtherDescription}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <TextArea rows={4} maxLength={1000} showCount/>
                            </Form.Item>
                            </div>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <div className="block_item_form" >
                                <Space.Compact>
                                    <Form.Item
                                        label={t('general.start_date_period')}
                                        name={FormField.periodStart}
                                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}

                                    >
                                        <DatePicker onChange={handleStartDateChange} format={dateFormat} placeholder={t('general.select_date')} />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('general.end_date_period')}
                                        name={FormField.periodEnd}
                                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}

                                    >
                                        <DatePicker disabledDate={disableEndDate} format={dateFormat} placeholder={t('general.select_date')} />
                                    </Form.Item>
                                </Space.Compact>
                            </div>
                            <div className="block_item_form" >
                            <Text underline strong >Раздел расходов</Text>
                            <Form.Item
                                label={t('financial_indicators.salary_expenses')}
                                name={FormField.expensesSalary}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <Input type="number" />
                            </Form.Item>
                            <Form.Item
                                label={t('financial_indicators.property_maintenance_costs')}
                                name={FormField.expensesRealEstateMaintenance}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <Input type="number" />
                            </Form.Item>
                            <Form.Item
                                label={t('financial_indicators.expenses_for_maintenance_movable_property')}
                                name={FormField.expensesMovableProperty}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <Input type="number" />
                            </Form.Item>
                            <Form.Item
                                label={t('financial_indicators.other_expenses')}
                                name={FormField.expensesOther}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <Input type="number" />
                            </Form.Item>
                            <Form.Item
                                label={t('Прочие расходы (Описание)')}
                                name={FormField.expensesOtherDescription}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <TextArea rows={4} maxLength={1000} showCount/>
                            </Form.Item>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </DraggableModal>
        </>
    )
}
